import { render, staticRenderFns } from "./NotificationSettings.vue?vue&type=template&id=3550d5fc&scoped=true"
import script from "./NotificationSettings.vue?vue&type=script&lang=js"
export * from "./NotificationSettings.vue?vue&type=script&lang=js"
import style0 from "./NotificationSettings.vue?vue&type=style&index=0&id=3550d5fc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3550d5fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3550d5fc')) {
      api.createRecord('3550d5fc', component.options)
    } else {
      api.reload('3550d5fc', component.options)
    }
    module.hot.accept("./NotificationSettings.vue?vue&type=template&id=3550d5fc&scoped=true", function () {
      api.rerender('3550d5fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Modal/NotificationSettings.vue"
export default component.exports